import { Box, Icon, Spinner, Text } from '@chakra-ui/core';
import React, { memo } from 'react';
import { IconType } from 'react-icons';
import { withEffectCardWrapper } from '../withEffectCardWrapper';

interface BlurCardProps {
  label: string;
  icon: IconType;
  isActive: boolean;
  isLoading: boolean;
  isApplying: boolean;
  onClick: () => void;
}

export const BlurCard = withEffectCardWrapper(
  memo(function BlurCard({ label, icon, isActive, isLoading, isApplying, onClick }: BlurCardProps) {
    return (
      <Box as="button" onClick={isApplying || isLoading || isActive ? undefined : onClick} py={3} px={2} w="100%" h="100%">
        <Box display="flex" alignItems="center" justifyContent="center" h="40px" mb="4px">
          {isLoading ? (
            <Spinner size="sm" color={isActive ? 'blue.500' : 'gray.400'} thickness="2px" />
          ) : (
            <Icon as={icon} color={isActive ? 'blue.500' : 'gray.600'} width="40px" height="40px" />
          )}
        </Box>

        <Text fontSize="11px" fontWeight={isActive ? '600' : '400'} color={isActive ? 'blue.600' : 'gray.600'}>
          {label}
        </Text>
      </Box>
    );
  }),
);
